var _circle, _path, _path2, _rect, _rect2, _circle2, _path3;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgCatShops(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    viewBox: "0 0 56 56",
    fill: "none",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _circle || (_circle = /*#__PURE__*/React.createElement("circle", {
    cx: 28,
    cy: 28,
    r: 28,
    fill: "#E3F3EF"
  })), _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M17 24.5 19.5 17h17l2.5 7.5H17Z",
    fill: "#0B1739"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M16 24.5h24l-1.2 3.2c-.4 1-1.4 1.6-2.5 1.6H19.7c-1.1 0-2.1-.6-2.5-1.6L16 24.5Z",
    fill: "#12B5A2"
  })), _rect || (_rect = /*#__PURE__*/React.createElement("rect", {
    x: 18,
    y: 29.3,
    width: 20,
    height: 12.7,
    rx: 2,
    fill: "#12B5A2"
  })), _rect2 || (_rect2 = /*#__PURE__*/React.createElement("rect", {
    x: 25,
    y: 33,
    width: 6,
    height: 9,
    rx: 1,
    fill: "#0B1739",
    opacity: 0.25
  })), _circle2 || (_circle2 = /*#__PURE__*/React.createElement("circle", {
    cx: 28,
    cy: 21,
    r: 3.2,
    fill: "#12B5A2",
    stroke: "#fff",
    strokeWidth: 1.2
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    d: "M28 19.2v3.6M26.4 21h3.2",
    stroke: "#fff",
    strokeWidth: 1.1,
    strokeLinecap: "round"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgCatShops);
export default __webpack_public_path__ + "static/media/cat-shops.6367064936d0d7e01c5c4c952e398e4d.svg";
export { ForwardRef as ReactComponent };